import zxcvbn from 'zxcvbn'

const removeFromList = (list, indexToRemove, setErrorList) => {
  list.splice(indexToRemove, 1)
  setErrorList(list)
}

export const passwordValidateFunction = (password, setErrorList, MIN_LENGTH_PW, errorList, passwordReqs) => {
  const list = errorList

  // ERROR #1 - MIN_LENGTH_PW characters in length -----------------
  if (password.length >= MIN_LENGTH_PW) {
    const indexToRemove = list.indexOf('minLength')
    // if the value is in the list
    if (indexToRemove !== -1) {
      removeFromList(list, indexToRemove, setErrorList)
    }
  }

  if (password.length < MIN_LENGTH_PW) {
    //check if it not there already
    if (!list.includes('minLength')) {
      list.push('minLength')
      setErrorList(list)
    }
  }

  // ERROR #2 - At least one uppercase letter -----------------
  const upperCaseRegex = /[A-Z]/g
  if (password.match(upperCaseRegex)) {
    const indexToRemove = list.indexOf('upperCase')
    // if the value is in the list
    if (indexToRemove !== -1) {
      list.splice(indexToRemove, 1)
      setErrorList(list)
    }
  }

  if (!password.match(upperCaseRegex)) {
    //check if it not there already
    if (!list.includes('upperCase')) {
      list.push('upperCase')
      setErrorList(list)
    }
  }

  // ERROR #3 - At least one lowercase letter -----------------
  const lowerCaseRegex = /[a-z]/g
  if (password.match(lowerCaseRegex)) {
    const indexToRemove = list.indexOf('lowerCase')
    // if the value is in the list
    if (indexToRemove !== -1) {
      list.splice(indexToRemove, 1)
      setErrorList(list)
    }
  }

  if (!password.match(lowerCaseRegex)) {
    //check if it not there already
    if (!list.includes('lowerCase')) {
      list.push('lowerCase')
      setErrorList(list)
    }
  }

  // ERROR #4 - At least one number letter -----------------
  const numberRegex = /\d/

  if (numberRegex.test(password)) {
    const indexToRemove = list.indexOf('digit')
    // if the value is in the list
    if (indexToRemove !== -1) {
      list.splice(indexToRemove, 1)
      setErrorList(list)
    }
  }

  if (!numberRegex.test(password)) {
    //check if it not there already
    if (!list.includes('digit')) {
      list.push('digit')
      setErrorList(list)
    }
  }

  const specialCharRegex = /\W/

  if (specialCharRegex.test(password)) {
    const indexToRemove = list.indexOf('specialChar')
    // if the value is in the list
    if (indexToRemove !== -1) {
      list.splice(indexToRemove, 1)
      setErrorList(list)
    }
  }

  if (!specialCharRegex.test(password)) {
    //check if it not there already
    if (!list.includes('specialChar')) {
      list.push('specialChar')
      setErrorList(list)
    }
  }

  if (zxcvbn(password).score >= 4) {
    const indexToRemove = list.indexOf('complexity')
    // if the value is in the list
    if (indexToRemove !== -1) {
      list.splice(indexToRemove, 1)
      setErrorList(list)
    }
  }

  if (zxcvbn(password).score < 2) {
    if (!list.includes('complexity')) {
      list.push('complexity')
      setErrorList(list)
    }
  }
}
